import { render, staticRenderFns } from "./AddEditSchedule.vue?vue&type=template&id=1d87e4ea&"
import script from "./AddEditSchedule.vue?vue&type=script&lang=js&"
export * from "./AddEditSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports